import styled from "styled-components";
import { useState } from "react";
import image from "../../../images/common/HeadSilhouette.png";
import membershipBadge from "../../../images/common/NewPremiumBadge.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import {FC} from "react";
import { GenericUpdateDTO, User } from "../../../models/user";
import UserService from "../../../services/user"
import useNotyf from "../../../context/useNotify";
import { useUser } from "../../../context/useUser";
import HelperService from "../../../services/helper";
import { isImageSquare } from "../../../utils/formatString";
import UpdateProfileImageModal from "./UpdateProfileImageModal";
import ReactModal from "../../common/ReactModal";

interface Props {
  player: User;
}

const PlayerPicture: FC<Props> = ({
  player,
}) => {
  const { setUser } = useUser()
  const notyf = useNotyf()

  // API
  const fetchUser = async (userId: string) => {
    try {
      const { user } = await UserService.checkToken()
      setUser(user)
    } catch (err) {
      console.error(`Error fetching user: ${err}`)
      HelperService.showNotfyErr(notyf, err, "An error occurred fetching the user.")
    }
  }

  // API 
  const updateUser = async (profileImage: string) => {
    try {
      const square = await isImageSquare(profileImage)
      if (!square) {
        notyf.error("Image must be square.")
        return
      }
      const updateObj = { profileImage: profileImage }
      const dto: GenericUpdateDTO = { id: player._id, updateObj: updateObj }

      const { user } = await UserService.genericUpdate(dto)
      await fetchUser(user._id)
      notyf.success("Your details have been updated successfully.")
    } catch (err) {
      console.error(`Error updating details: ${err}`)
      HelperService.showNotfyErr(notyf, err, "Error updating details.")
    }
  }

  // edit player image
  const [editImage, setEditImage] = useState(false);
  const handleClickEditImage = () => {
    setEditImage(!editImage);
  };
  const handleCloseEditImage = () => {
    setEditImage(false);
  };
  const handleSubmitEditImage = (newProfileImageUrl: string) => {
    updateUser(newProfileImageUrl)
  };

  return (
    <Wrapper>
      <Container>
        <TextContainer className="gradient-gray-light black-border">
            <FaIcon>
              <FontAwesomeIcon
                onClick={handleClickEditImage}
                icon={faPenToSquare}
                style={{ cursor: "pointer" }}
              />
            </FaIcon>
          { player.profileImage
              ?
              <Image src={player.profileImage}></Image>
          :
              <Image src={image}></Image>
          }
        </TextContainer>

        <MembershipContainer className="black-border">
          <TextContainer className="gradient-gray heading">
            <Text className="fw-bold">MEMBERSHIP</Text>
          </TextContainer>

          <BadgeImageContainer className="gradient-gray-light">
            {player.isPremium === true ? (
              <BadgeImage src={membershipBadge}></BadgeImage>
            ) : (
              <h4>Standard</h4>
            )}
          </BadgeImageContainer>
        </MembershipContainer>
      </Container>

      <ReactModal
        modalOpen={editImage}
        closeModal={handleCloseEditImage}
        component={<UpdateProfileImageModal onClose={handleCloseEditImage} />}
      />
    </Wrapper>
  );
};

export default PlayerPicture;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem;
  @media (max-width: 768px) {
    display: flex;
    /* align-items: center; */
    justify-content: center;
  }
`;
const Container = styled.div`
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  background: linear-gradient(120deg, #000000ff 60%, #040a2cff 100%);
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 5px 1px #00eaff;
  border-radius: 18px;
  padding: 1.5rem 1.2rem;
  position: relative;
  @media (max-width: 992px) {
    flex-direction: row;
    gap: 2rem;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    width: 320px;
  }
`;
// player
const ImageContainer = styled.div`
  height: 200px;
  width: 100%;
  background-color: rgba(117, 117, 117, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 1px 5px rgb(74, 74, 74);
  border-radius: 8px;
  /* border: solid 2px rgb(65, 65, 65); */
  position: relative;
`;

const Image = styled.img`
  height: 180px;
  border-radius: 8px;
`;
const FaIcon = styled.div`
  color: white;
  /* padding: 1rem 0; */
  position: absolute;
  top: 0;
  left: 0;
  margin: 0.5rem;
`;

// membership
const MembershipContainer = styled.div`
  height: 200px;
  width: 100%;
  box-shadow: 0px 1px 5px rgb(38, 38, 38);
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 8px 1px #00eaff;
  border-radius: 14px;
  padding: 1.2rem 1rem;
  margin-top: 0.5rem;
`;
const TextContainer = styled.div`
  background: none;
  border: none;
  box-shadow: none;
  border-radius: 0;
  padding: 0;
  margin-bottom: 0.5rem;
  margin-top: -0.5rem;
`;
const Text = styled.h4`
  margin: 0;
  padding: 0;
`;

const BadgeImageContainer = styled.div`
  background: none;
  border: none;
  box-shadow: none;
  border-radius: 0;
  padding: 0;
  margin-top: 0.5rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 140px;
`;
const BadgeImage = styled.img`
  /* height: 130px; */
  height: 100%;
  @media (max-width: 992px) {
    height: 120px;
  }
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
